import { ROUTES } from '@/constants/routes';

/** Prevents open redirects when honouring ?next= query parameters */
export function sanitiseInternalPath(candidate: string | null): string {
  if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) {
    return ROUTES.dashboard;
  }
  return candidate;
}
